<script setup>
import { inject } from 'vue';
import { CdrButton, CdrLink } from '@rei/cedar';

const metricsClick = inject('metricsClick');

const props = defineProps({
  primary: {
    type: String,
    required: true,
  },
  primaryDisabled: {
    type: Boolean,
    default: false,
  },
  secondary: {
    type: String,
    required: true,
  },
  link: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['primary', 'secondary']);

const handlePrimaryClick = () => {
  metricsClick('StepNavigation', 'next');
  emit('primary');
};

const handleSecondaryClick = () => {
  metricsClick('StepNavigation', 'back');
  emit('secondary');
};
</script>

<template>
  <div class="step-navigation">
    <CdrButton
      class="step-navigation__primary"
      :disabled="props.primaryDisabled"
      data-ui="step-navigation-primary"
      size="large"
      @click="handlePrimaryClick"
    >
      {{ props.primary }}
    </CdrButton>
    <div class="step-navigation__row">
      <CdrButton
        modifier="secondary"
        data-ui="step-navigation-secondary"
        size="large"
        @click="handleSecondaryClick"
      >
        {{ props.secondary }}
      </CdrButton>
      <CdrLink
        v-if="props.link"
        :href="props.link.href"
        size="large"
        data-ui="step-navigation-link"
        data-analytics-id="day-cancellation:StepNavigation_i dont want to cancel"
        standalone
      >
        {{ props.link.name }}
      </CdrLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.step-navigation {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: $cdr-space-one-and-a-half-x;

  &__primary {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  &__row {
    display: flex;
    flex-direction: row;
    gap: $cdr-space-one-x;
  }

  @include cdr-sm-mq-up {
    &__primary {
      width: fit-content;
    }
  }
}
</style>
